// @flow strict

import * as React from 'react'
import {
  type NavigationItemProps,
  NavigationItem,
} from './NavigationComponents/NavigationItem'
import NavigationWrapper from './NavigationComponents/NavigationContainer'

import Button from '../../atoms/Button'
import { URLS } from '../../../constants'
import TrackEvents from '../../atoms/TrackEvents/TrackEvents'

import styles from './DefaultMainNavigation.module.scss'
import navigationListStyles from './NavigationList.module.scss'
// Images
import jigsawIcon from './NavIcons/jigsaw-icon.svg'
import heartIcon from './NavIcons/heart-icon.svg'
import switchIcon from './NavIcons/switch-icon.svg'

export const NAVIGATION_LINKS: NavigationItemProps[] = [
  {
    text: 'Accounts',
    // label: 'New', TODO - Add in when Paid launches
    dropdownItems: [
      { href: '/i/current-account/', text: 'Monzo Current Accounts' },
      { href: '/i/monzo-plus/', text: 'Monzo Plus Accounts' },
      {
        href: '/i/monzo-premium/',
        text: 'Monzo Premium Accounts',
        isNew: true,
      },
      { href: '/i/business/', text: 'Monzo Business Accounts' },
      { href: '/features/joint-accounts/', text: 'Monzo Joint Accounts' },
      { href: '/features/16-plus/', text: 'Monzo 16 - 17 Accounts' },
      { href: '/i/switch/', text: 'Switch to Monzo', icon: switchIcon },
    ],
    label: 'New',
  },
  {
    text: 'Savings',
    dropdownItems: [
      { href: '/i/savingwithmonzo/', text: 'Saving with Monzo' },
      { href: '/features/savings/', text: 'Interest Rates' },
      { href: '/isa/', text: 'Cash ISAs' },
    ],
  },
  {
    text: 'Borrowing',
    dropdownItems: [
      { href: '/i/overdrafts/', text: 'Overdrafts' },
      { href: '/i/loans/', text: 'Loans' },
      {
        href: '/blog/2019/11/12/what-are-unsecured-loans/',
        text: 'What are unsecured loans?',
        icon: jigsawIcon,
      },
    ],
  },
  {
    text: 'Features',
    dropdownItems: [
      {
        href: '/i/pots/',
        text: 'Pots',
      },
      {
        href: '/features/travel/',
        text: 'Travelling with Monzo',
      },
      {
        href: '/features/energy-switching/',
        text: 'Energy switching',
      },
      {
        href: '/i/shared-tabs-more/',
        text: 'Bill splitting',
      },
      {
        href: '/community/making-monzo/',
        text: 'Making Monzo',
        icon: heartIcon,
      },
    ],
  },

  {
    href: '/help/',
    text: 'Help',
  },
]

export default () => (
  <NavigationWrapper
    activeContext="personal"
    styles={styles}
    navigationListStyles={navigationListStyles}
    navLinks={NAVIGATION_LINKS}
    callToAction={
      <TrackEvents category="conversion" action="download app" label="header">
        <Button href={URLS.ADJUST_BOTH_STORE}>Sign up</Button>
      </TrackEvents>
    }
  >
    {NAVIGATION_LINKS.map(props => (
      <NavigationItem
        {...props}
        key={props.text}
        navigationListStyles={navigationListStyles}
      />
    ))}
  </NavigationWrapper>
)
